import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none",
  viewBox: "-0.75 -0.75 21 21"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m10.432 1.518 2.215 4.471a.71.71 0 0 0 .571.418l4.89.724a.752.752 0 0 1 .417 1.296l-3.524 3.496a.74.74 0 0 0-.223.668l.85 4.917a.767.767 0 0 1-1.114.808l-4.402-2.326a.82.82 0 0 0-.724 0l-4.402 2.326a.766.766 0 0 1-1.114-.808l.85-4.972a.74.74 0 0 0-.223-.669L.933 8.427a.752.752 0 0 1 .46-1.296l4.889-.724a.71.71 0 0 0 .57-.418l2.215-4.47a.752.752 0 0 1 1.365 0"
    }, null, -1)
  ]));
}
const Star = { render };
export {
  Star as default,
  render
};
//# sourceMappingURL=Star.svg.js.map
